/* eslint-disable semi */
import { FetchBase } from '../shared/FetchBase';

export interface AbnDetails {
    abn: string;
    // Add other relevant fields here
}

export class AbnFetch extends FetchBase {
  constructor() {
    super('', '/api/abn');
  }

  async getByAbn(abn: string): Promise<AbnDetails> {
    return this.ajaxRequest('GET', `?abn=${abn}`);
  }
}
